<template>
  <div class="container">
    <el-row :gutter="10">
    <el-row :gutter="5" class="class-dish">
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            第<span class="danger-text">{{currentIndex + 1}}</span><span>/{{`${dishModelCount}`}}个碗</span>
            <h3 class="header-title">名称: {{currentDishModel.dish_name}}</h3>
            <div class="btn-wrapper-1">
              <el-button type="primary" :disabled="currentIndex < 1"  @click="preDishModel">上一个例图</el-button>
              <el-button type="primary" :disabled="currentIndex === dishModelCount - 1"  @click="nextDishModel">下一个例图
              </el-button>
              <el-button type="danger" @click="checkComplete" v-if="selfCheck">自查结束</el-button>
              <span v-else>
                  <el-button type="success" v-if="userGroup > 99" :disabled="currentIndex !== dishModelCount - 1"
                             @click="checkPass">审核通过</el-button>
                <el-button type="danger" v-if="userGroup > 99" @click="checkFail">审核不通过</el-button>
                </span>
            </div>
          </div>
          <div class="image-wrapper">
            <el-badge :value="batchImagesBlongCurrentModel.length" class="item">
              <img :src="currentDishModel.dish_image_url" width="150" alt="">
            </el-badge>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card >
          <div slot="header" class="clearfix">
            <h3 class="header-title danger-text">已纠错图片</h3>
          </div>
          <div class="image-wrapper" v-if="selfCheck">
            <div class="image-item" v-for="dish in  batchImageListUnmarked" :key="dish.dish_uuid">
              <el-popover
                popper-class="big-img"
                ref="popover2"
                placement="top-start"
                trigger="hover">
                <img :src="dish.dish_img_url" slot="reference" alt="" width="50px" height="50px" >
                <div class="big-img-wrapper">
                  <img :src="dish.dish_img_url" alt=""   >
                </div>
              </el-popover>
            </div>
          </div>
          <div class="image-wrapper" v-else>
            <div class="image-item" v-for="dish in checkTextObjImageList" :key="dish.dish_uuid">
              <el-popover
                popper-class="big-img"
                ref="popover2"
                placement="top-start"
                trigger="hover">
                <img :src="dish.dish_img_url" slot="reference" alt="" width="50px" height="50px" >
                <div class="big-img-wrapper">
                  <image-item :image="dish"></image-item>
                </div>
              </el-popover>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="delete-card">
          <div slot="header" class="clearfix">
            <h3 class="header-title danger-text">回收站</h3>
            <!--<el-button style="float: right; padding: 3px 0" type="text" @click="handleClick">查看</el-button>-->
          </div>
          <div class="image-wrapper">
            <div class="image-item" v-for="dish in batchImageListDelete" :key="dish.dish_uuid">
              <el-popover
                popper-class="big-img"
                ref="popover2"
                placement="top-start"
                trigger="hover">
                <img :src="dish.dish_img_url" slot="reference" alt="" width="50px" height="50px" >
                <div class="big-img-wrapper" v-if="selfCheck === true">
                  <el-button  type="primary" class="btn" style="position: absolute"
                              @click="unDelete(dish)">撤回
                  </el-button>
                  <img :src="dish.dish_img_url" alt=""   >
                </div>
                <div v-else>
                  <imageItem
                    :image="dish">
                  </imageItem>
                </div>
              </el-popover>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <h2 class="process-title">
      <!--// 自查-->
      <span v-if="selfCheck">从下列例图查找与本例图 <span class="strong-text">不相符</span> 的图片, 鼠标悬浮之后点击删除.</span>
      <span v-else>检查下列图片,如果和上面的例图<span class="strong-text">不相符</span>,请点击 图片上的<i
        class="el-icon-edit danger-text"></i>输入修改意见</span>
      <!--审查-->
    </h2>
    <imageMarkWrapperforselfcheck
      v-if="batchImagesBlongCurrentModel && batchImagesBlongCurrentModel.length > 0 && selfCheck"
      :images="batchImagesBlongCurrentModel"
      :current_class_id="currentDishModel.class_id"
      :selfCheck="selfCheck"
    >
    </imageMarkWrapperforselfcheck>
    <image-mark-wrapper1
      v-if="batchImagesBlongCurrentModel && batchImagesBlongCurrentModel.length > 0 && !selfCheck"
      :images="batchImagesBlongCurrentModel"
      :current_class_id="currentDishModel.class_id"
      :selfCheck="selfCheck"
    >
    </image-mark-wrapper1>
    <h3 class="tip-wrapper" v-else>
      当前例图暂无标注的碗碟
      <el-button type="primary" :disabled="currentIndex < 1"  @click="preDishModel">上一个例图</el-button>
      <el-button type="primary" :disabled="currentIndex === dishModelCount - 1"  @click="nextDishModel">下一个例图
      </el-button>
    </h3>
  </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import {apiChangeBatchState, apiGetBatchImageList} from '@/api';
import imageMarkWrapper1 from './imageMarkWrapper1';
import imageMarkWrapperforselfcheck from './imageMarkWrapperforselfcheck';
import {errorMessage, successMessage} from '@/lib/msg';
import imageItem from '_c/imageItemForCheck';

export default {
  name: 'checkProcess',
  components: {
    imageMarkWrapper1,
    imageMarkWrapperforselfcheck,
    imageItem
  },
  data () {
    const validatePass = (rule, value, callback) => {
      console.log(`ssssssssssssssss`, value);
      if (value === '') {
        callback(new Error('请输出审查意见'));
      } else {
        callback();
      }
    };
    return {
      currentIndex: 0,
      checkFailReasonShow: false,
      checkFailReason: ''
    };
  },
  mounted () {
    this.emitLoading();
    this.getImagesByBatchTag();
    this.clearCheckTextObj();
    setTimeout(() => {
      this.removeLoading();
    }, 500);
  },
  methods: {
    ...mapMutations([
      'setMarkedImageList',
      'changeCurrentDishModelIndex',
      'setBatchTag',
      'emitLoading',
      'removeLoading',
      'setBatchList',
      'setBatchImageList',
      'setSubTitle',
      'unMark',
      'clearCheckTextObj'
    ]),
    // 保存标记状态到本地
    saveLocal () {

    },
    unDelete (dish) {
      this.unMark({dish_img_uuid: dish.dish_img_uuid});
    },
    // handleClick () {
    //   this.currentIndex = '-1';
    // },
    showCheckFailReasonDialog () {
      this.checkFailReasonShow = true;
    },
    cancelDialog () {
      this.checkFailReason = '';
      this.checkFailReasonShow = false;
    },
    async checkFail () {
      // this.$prompt('请输入审查建议', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputValidator (value) {
      //     if (!value) {
      //       return false;
      //     }
      //   },
      //   inputErrorMessage: '审查建议不能为空'
      // }).then(async ({ value }) => {
      this.$confirm(`${this.checkTextObjList.length || 0}张图片不合格, 是否提交`, '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '再检查检查',
        type: 'warning'
      }).then(async () => {
        try {
          await apiChangeBatchState({
            system_id: 1,
            batch_tag: this.batch_tag,
            batch_state: 4,
            batch_comment: this.stringifyCheckTextObjList,
            apiKey: this.apiKey
          });
          this.checkFailReason = '';
          this.checkFailReasonShow = false;
          this.emitLoading();
          this.removeLoading();
          this.setBatchTag('');
          successMessage('审核成功');
          this.clearCheckTextObj();
          this.$router.push('/dataMark/checkList');
        } catch (e) {
          this.removeLoading();
          errorMessage('审核失败');
        }
      }).catch(e => {
        // console.log(e);
      });
    },
    async checkPass () {
      if (this.checkTextObjList && this.checkTextObjList.length > 0) {
        this.$message.error('当前批次中有被纠错图片, 无法通过');
      } else {
        this.$confirm('是否审查通过?', '提示', {
          confirmButtonText: '通过',
          cancelButtonText: '再检查检查',
          type: 'warning'
        }).then(async () => {
          try {
            await apiChangeBatchState({
              system_id: 1,
              batch_tag: this.batch_tag,
              batch_state: 3,
              batch_comment: '',
              apiKey: this.apiKey
            });
          } catch (e) {
            console.log(e);
            errorMessage('审核失败');
          }
          this.setBatchTag('');
          successMessage('审核成功');
          this.clearCheckTextObj();
          this.$router.push('/dataMark/checkList');
        }).catch(() => {
        });
      }
    },
    // 查询批次图片
    async getImagesByBatchTag () {
      if (this.$route.params.selfCheck && this.$route.params.selfCheck === true) {
        // 从vuex中获取
      } else {
        // 请求服务器中相应的
        let res = await apiGetBatchImageList({
          canteen_id: this.listQuery.canteen.canteen_id,
          batch: this.batch_tag,
          apiKey: this.apiKey
        });
        this.setMarkedImageList(res);
      }
    },
    // 下一个例图
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    submitMarkedData () {
      this.$alert('标注还未完成, 请继续标注', '', {
        confirmButtonText: '确定'
      });
    },
    checkComplete () {
      this.$alert('即将跳转到标注页面', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          this.$router.push({
            name: 'markProcess1',
            params: {
              selfCheck: true
            }
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'markedImageList',
      'modelList',
      'listQuery',
      'userinfo',
      'checkTextObjList'
    ]),
    selfCheck () {
      if (this.$route.params.selfCheck) {
        return this.$route.params.selfCheck;
      } else {
        return false;
      }
    },
    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    markedCount () {
      return this.$store.state.markedCount[this.currentDishModel.class_id] || 0;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex];
    },
    batch_tag () {
      return this.$store.getters.batchTag;
      // return this.$route.params.batch_tag;
    },
    batchImageListUnmarked () {
      return this.markedImageList.filter((image) => {
        return !image.class_id;
      });
    },
    batchImagesBlongCurrentModel () {
      return this.markedImageList.filter((image) => {
        return image.class_id === this.currentDishModel.class_id;
      });
    },
    batchImageListDelete () {
      return this.markedImageList.filter((image) => {
        return image.class_id === '-1';
      });
    },
    stringifyCheckTextObjList () {
      return JSON.stringify(this.checkTextObjList);
    },
    checkTextObjUUIDList () {
      return this.checkTextObjList.map(a => a.dish_img_uuid);
    },
    checkTextObjImageList () {
      let arr = [];
      this.checkTextObjUUIDList.forEach(a => {
        let target = this.$_.find(this.batchImagesBlongCurrentModel, function (b) {
          return a === b.dish_img_uuid;
        });
        if (target) {
          arr.push(target);
        }
      });
      return arr;
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    .tip-wrapper {
      display: inline-block;
      width: auto;
      padding: 20px;
      border: 2px solid red;
      border-radius: 20px;
    }
    .unMarked-card {
      height: 100%;
    }
    .header-title {
      display: inline-block;
    }
    .box-card {
      .btn-wrapper-1 {
        display: inline-block;
        margin-top: -10px;
        float: right;
      }
    }
    .btn-wrapper {
      padding-top: 50px;
      width: 80%;
      .btn-wrapper-1 {
        display: inline-block;
        margin-top: -10px;
        float: right;
      }
    }
    .image-wrapper {
      height: 150px;
      .image-item {
        display: inline-block;
        .big-img {
          .big-img-wrapper {
            position: relative;
            .btn {
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }

      }
    }
    .process-title {
      .strong-text {
        color: #ff0000
      }
    }
  }

</style>
